import { render, staticRenderFns } from "./AccountOpePanel.vue?vue&type=template&id=12a5e828"
import script from "./AccountOpePanel.vue?vue&type=script&lang=js"
export * from "./AccountOpePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports